// removed by extract-text-webpack-plugin
module.exports = {"White":"#FFFFFF","BreakpointFromMedium":"(min-width: 640px)","expandableSection":"G677707","expandedContent":"Gfbd67e"};